import type { StaticDatabase } from "@-/dev.improve.haniverse.database.static";
import type { UnpackedGraphemeStrokes } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.strokes";
import { hasLength } from "@-/com.npmjs.ts-array-length";

export type Stroke = {
  median: readonly [number, number][];
  path: string;
};

export async function fetchGraphemesByGlyphsForStrokes(
  staticDb: StaticDatabase,
  glyphs: readonly string[],
): Promise<Record<string, readonly Stroke[]>> {
  if (hasLength(glyphs, 0)) {
    return {};
  }

  const rows = await staticDb(import.meta.location).query.grapheme.findMany({
    columns: { glyph: true },
    where: { glyph: { in: [...glyphs] } },
    with: { strokeData: { columns: { strokeData: true } } },
  });

  const out: Record<string, readonly Stroke[]> = {};
  for (const row of rows) {
    const strokes: Stroke[] = (row.strokeData?.strokeData ?? []).map(
      ({ medians, path }: UnpackedGraphemeStrokes) => ({
        median: medians,
        path,
      }),
    );
    out[row.glyph] = strokes;
  }
  return out;
}
